'use client';
import { createQuery, SessionStorageCache } from '@s7/query';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const useFooterQuery = createQuery(({ cache, url, code, device, lang })=>_extends({}, cache && {
        persist: cache
    }, {
        query: [
            url,
            {
                searchParams: {
                    code,
                    device,
                    lang
                }
            }
        ],
        cache: SessionStorageCache
    }));

export { useFooterQuery };
//# sourceMappingURL=Footer.js.map
